import SurveyPreviewModal from '@/components/CommonComponents/SurveyPreviewModal';
import { SurveyListItem } from '@/types/survey.types';

interface SurveyManagementPreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  getUpdatedPreviewSurvey: () => SurveyListItem | null;
}

const SurveyManagementPreviewModal: React.FC<SurveyManagementPreviewModalProps> = ({
  isOpen,
  onClose,
  getUpdatedPreviewSurvey,
}) => {
  const currentSurvey = getUpdatedPreviewSurvey();

  return <SurveyPreviewModal isOpen={isOpen} onClose={onClose} survey={currentSurvey} />;
};

export default SurveyManagementPreviewModal;
